<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import PlanosAvisoAPI from 'dashboard/api/planosAviso';
import Banner from 'dashboard/components-next/banner/Banner.vue';

const { t } = useI18n();
const { isAccountAdmin } = useAdmin();
const { accountScopedRoute } = useAccount();
// O aviso só podia ser dispensado: sem caminho até a página de Planos, a
// decisão que ele sugere ficava sem próximo passo.
const planosRoute = accountScopedRoute('planos_index');
const aviso = ref(null);
const carregando = ref(false);

const carregar = async () => {
  // O aviso é só de administrador no servidor. Para o atendente o GET voltava
  // 401 a cada visita ao Hub; sem papel de admin nem pergunta.
  if (!isAccountAdmin.value) return;
  carregando.value = true;
  try {
    const response = await PlanosAvisoAPI.get();
    aviso.value = response.data?.aviso || null;
  } catch {
    aviso.value = null;
  } finally {
    carregando.value = false;
  }
};

const dispensar = async () => {
  try {
    await PlanosAvisoAPI.dispensar();
    aviso.value = null;
  } catch {
    // keep the banner if dismiss failed
  }
};

onMounted(carregar);
</script>

<template>
  <div v-if="aviso && !carregando" class="px-4 pt-3">
    <Banner
      color="blue"
      :action-label="t('PLANOS.AVISO.DISMISS')"
      @action="dispensar"
    >
      <p class="font-medium">{{ t('PLANOS.AVISO.TITLE') }}</p>
      <p class="mt-1">{{ aviso.mensagem }}</p>
      <RouterLink
        :to="planosRoute"
        class="link mt-1 inline-flex min-h-11 items-center gap-1 font-semibold underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-blue-9"
        data-testid="aviso-upgrade-ver-planos"
      >
        {{ t('PLANOS.AVISO.SEE_PLANS') }}
        <span class="i-ri-arrow-right-line size-4" aria-hidden="true" />
      </RouterLink>
    </Banner>
  </div>
</template>
